import { insiderPolicies, principles } from "@/mocks/homeContent";

export default function Insider() {
  return (
    <section id="insider" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-2 lg:gap-16">
        <div className="flex flex-col justify-center">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-300">
            <span className="h-px w-6 bg-accent-500"></span> 知情者通道
          </span>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-background-50 md:text-4xl">
            你只管表达，
            <br className="hidden md:block" />
            安全由我们把守
          </h2>
          <p className="mt-5 text-base leading-relaxed text-background-200">
            面向不愿公开身份的知情者，我们提供加密、匿名的私密沟通路径。从加密存储、分阶段披露到去识别化处理，每一步都以"最小必要"为原则。
          </p>

          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {insiderPolicies.map((p) => (
              <div
                key={p.title}
                className="rounded-lg border border-background-200/15 bg-white/5 p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500/20 text-accent-300">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <h3 className="mt-3 font-display text-base font-bold text-background-50">
                  {p.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-background-300">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col justify-center rounded-lg border border-background-200/15 bg-white/5 p-6 md:p-8">
          <h3 className="font-display text-xl font-bold text-background-50">我们始终坚守的原则</h3>
          <p className="mt-2 text-sm text-background-300">
            无论线索来自哪条通道，以下底线贯穿受理、核验与发布的全程。
          </p>
          <ul className="mt-6 space-y-3.5">
            {principles.map((pr, i) => (
              <li key={pr} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-600 font-display text-xs font-bold text-background-50">
                  {i + 1}
                </span>
                <span className="text-sm leading-relaxed text-background-100">{pr}</span>
              </li>
            ))}
          </ul>
          <a
            href="#contact"
            className="mt-8 inline-flex items-center justify-center gap-2 rounded-md bg-background-50 px-5 py-3 text-sm font-medium text-foreground-950 whitespace-nowrap transition-colors hover:bg-accent-100"
          >
            以知情者身份发起沟通
            <i className="ri-lock-2-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}